import React from "react";
import TimeAgo from 'react-timeago';
import arabicStrings from 'react-timeago/lib/language-strings/ar';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import get from "lodash/get";
import { Link, ResponsiveImage } from "@quintype/components";
import {format} from "date-fns";
// Author component can accept these params.
// isLink : Basically changes the component clickable in any scenario.
// author : An author object which will have name, id, date & image.
// authors: An array of authors which will come from story API itself. If the authors array is present we'll ignore the author object.
// showDateOnly: Will hide the `Posted` string infront of every date.
// date   : pass the date value from story object
function Author(props) {
  // If there's only one author.
  if((props.author && !props.authors) || (props.authors && props.authors.length === 1)) {
    const author = props.authors ? props.authors[0] : props.author;
    return props.isLink ? <Link href={'/author/' + author.id}>
      <SingleAuthorTemplate config={props.config} author={author} {...props} />
    </Link> : <SingleAuthorTemplate config={props.config} author={author} {...props} />
  }
  // If there're mulitiple authors.
  if(props.authors && props.authors.length !== 1) {
    return <MultipleAuthorTemplate {...props}/>
  }
  // fallback
  return null;
}

const SingleAuthorTemplate = ({author, date, showDateOnly = false, config = {}}) => {
  const authorImage = author['avatar-url'] || author.image ;
  const postedKeyword = get(config, ['theme-attributes', 'lang']) !== 'ar' ? 'Posted' : '';
  return <div className="author">
    <AuthorImage {...author} />
    <div className="author__content">
      <h3 className="author__name" data-author-name="true">{author.name}</h3>
      {date && <div className="author__published-date" data-publish-date="true">
        <span className="author__posted-keyword">{ !showDateOnly && postedKeyword }</span> 
        <div className="author__time-stamp-wrapper">
          <TimeAgo date={date} formatter={(value, unit, suffix, date, defaultFormatter) => formatter(value, unit, suffix, date, defaultFormatter, config)} />
        </div>
      </div>}
    </div>
  </div>
}

const MultipleAuthorTemplate = (props) => {
  const authorsLength = props.authors.length;
  return <div className="author author--multiple">
    <div className="author__avatars">
    { props.authors.map(author => {
        return props.isLink
          ? <Link href={'/author/' + author.id} key={author.id} className="author__avatar-wrapper--is-link">
            <AuthorImage {...author} />
          </Link>
          : <AuthorImage {...author} />
      }) }
    </div>
    <div className="author__content">
      { props.authors.map((author, index, authors) => {
          return props.isLink
            ? <Link href={'/author/' + author.id} key={author.id}>
              <AuthorName author={author} index={index} authorsLength ={authorsLength} isLink/>
            </Link>
            : <AuthorName author={author} index={index} authorsLength ={authorsLength} key={author.id}/>
        }) }
      { props.date && <p className="author__published-date">
        { !props.showDateOnly && 'Posted' } <TimeAgo date={props.date} formatter={(value, unit, suffix, date, defaultFormatter) => formatter(value, unit, suffix, date, defaultFormatter, props.config)}/>
      </p>}
    </div>
  </div>
}

const AuthorName = ({author, index, authorsLength, isLink}) => {
    return <h3 className={`${isLink ? 'author__name--is-link' : ''} author__name`}>
      {index !== 0 && (index === authorsLength - 1 ? '&' : ',')} {author.name}
    </h3>
};

const AuthorImage = ({'avatar-url':image, 'avatar-s3-key':imageS3, metadata = {}, name}) => {
  if(imageS3) {
    return <div className="author__avatar">
      <ResponsiveImage slug={imageS3}
        metadata={metadata}
        aspectRatio={[1,1]}
        defaultWidth={48}
        imgParams={{auto: ['format','compress']}}
        alt={name}
      />
    </div>;
  }
  if(image) {
    return <div className="author__avatar">
      <img src={image} />
    </div>;
  }
  return null;
}

const FallbackAuthorImage = () => {
  // TODO: replace with a fallback image. and use it in AuthorImage component.
  return null;
}

function formatter(value, unit, suffix, date, defaultFormatter, config = {}) {
  if(get(config, ['theme-attributes', 'lang']) === 'ar') {
    const _formatter =  buildFormatter(arabicStrings);
    return _formatter.apply(this, [value, unit, suffix, date]);
  }
  return format(new Date(date), 'DD MMM, YYYY [at] HH:mm A');
}

export { Author };
